require('./style.less');

var BabySitterView = require('../../../../common/BabySitterView'),
    DocSelectView = require('./docSelect/view'),
    ComboPDFDropDown = require('./comboPdf/view');

require('jqIframeShim');
require('extendJQuery'); //(for unselectable)

module.exports = BabySitterView.extend({
    id: 'docNav',
    template: require('./template.hbs'),
    onRender: function() {
        this.ui.docBtnWr.unselectable();
    },
    ui: {
        docSelector:    '#docSelect',
        docPrev:        '.docPrev',
        docNext:        '.docNext',
        docFirst:       '.docFirst',
        docLast:        '.docLast',
        docNavBtns:     '.docNavBtn',
        docBtnWr:       '#docArrowNAV',
        comboPdfBtn:    '#combo-pdf-doc-nav-btn'
    },
    events: {
        'click @ui.docNavBtns'      : 'onClickDocNavBtn' //TODO: dom ref via jqCache -- b/c using multi
    },
    serializeData: function() {

        var activeDoc = this.options.activeDoc,
            docs = this.options.docCollection,
            docIndex = docs.indexOf(activeDoc),
            nDocs = docs.length;

      return {
          docSelectMarkup: DocSelectView.prototype.selectTemplate( activeDoc.documentName() ), //TODO: common code for dd select markup creation ...
          comboPDFDropDownMarkup: ComboPDFDropDown.prototype.getDropdownButton(),
          docXOfY: (docIndex + 1) + ' of ' + (nDocs),
          isFirstDoc: docIndex === 0,
          isLastDoc: docIndex === nDocs - 1,
          showComboPdfDropdown: this.options.vChannel.request('allowPDFCombo')
      };

    },
    onAttach: function() {

        this.children.add( new DocSelectView(
            _.extend(  _.pick(this.options, 'activeDoc', 'docCollection', 'vChannel'), {
                el: this.ui.docSelector,
                ddOptions: {
                    isSelect: 1,
                    container: this.options.vContainer,
                    dropUp: 1,
                    isSelectForceChangeOnClick: 1, //quick fix to force change if same doc provided more than once (no change ..)
                    maxWidth: 250
                }
            })
        ).render(), 'docSelect');

        this.children.add( new ComboPDFDropDown({
            el: this.ui.comboPdfBtn,
            vChannel: this.options.vChannel,
            ddOptions: {
                container: this.options.vContainer
            }
        }).render(), 'comboPDF');

        this.$el.iframeShim();
    },
    onClickDocNavBtn: function(e) {
        e.stopPropagation();
        var $trg = $(e.currentTarget),
            dir = $trg.attr('title');
        if ($trg.hasClass('disabled')) return false;
        this.options.vChannel.command('changeActiveDoc', dir);
    },
    toggleNavigability: function(on) {
        this.ui.docNavBtns.toggleClass('disabled', !on);
        this.children.findByCustom('docSelect').dropdown.toggleClass('disabled', !on); //TODO: better enabledOption for the plugin but this will work, if has the class click will disable in the plugin
    },
    onBeforeDestroy: BabySitterView.prototype.onBeforeDestroy,
    destroy: function() {
        BabySitterView.prototype.destroy.apply(this, arguments);

        this.$('*').remove(); //(a lot b/c 'multi-selector')
        this.off();

        this.$el.iframeShim('destroy');

        //TODO: still leak from iframe shim
        this.el = null; //still leak
        this.$el = null;
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/views/nav/navBar/view.js
 ** module id = 693
 ** module chunks = 0
 **/